module.exports = {
  PluginManifest: require('./lib/PluginManifest'),
  PluginStore: require('./lib/PluginStore'),
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/graylog-web-plugin/plugin.js
// module id = 251
// module chunks = 0